import React, { type JSX } from 'react';
import { MaskIcon } from '@/app/common/icons/MaskIcon';

const ArrowIcon = (): JSX.Element => (
  <MaskIcon category="Arrows" name="icon-chevron-down" size={19} footprint={[14, 9]} />
);

export default ArrowIcon;
